import { render, staticRenderFns } from "./ReservationSessionPrescriptions.vue?vue&type=template&id=b633a236"
import script from "./ReservationSessionPrescriptions.vue?vue&type=script&lang=js"
export * from "./ReservationSessionPrescriptions.vue?vue&type=script&lang=js"
import style0 from "./ReservationSessionPrescriptions.vue?vue&type=style&index=0&id=b633a236&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports